module.exports = __webpack_public_path__ + "img/a17.879b717e.jpeg";